import React, { useEffect } from 'react';
import { useTourSearchStore } from '../../store/TourSearchStore';
import TourSearchResults from './TourSearchResults';
import { useLocation } from 'react-router-dom';
export default function TourSearchResultsContainer() {
    const [_, actions] = useTourSearchStore();
    const { search } = useLocation();
    useEffect(() => {
        actions.searchURLParams(search);
    }, [search]);
    return React.createElement(TourSearchResults, null);
}
